var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "pause_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pause_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.92 24.667c-.524 0-.972-.186-1.345-.56a1.834 1.834 0 01-.56-1.345v-12.19c0-.524.187-.972.56-1.345.373-.373.821-.56 1.345-.56h1.048c.524 0 .972.187 1.345.56.373.373.56.821.56 1.345v12.19c0 .524-.187.973-.56 1.346-.373.373-.821.56-1.345.56H19.92zm-9.238 0c-.524 0-.972-.186-1.345-.56a1.834 1.834 0 01-.56-1.345v-12.19c0-.524.187-.972.56-1.345.373-.373.821-.56 1.345-.56h1.048c.524 0 .972.187 1.345.56.373.373.56.821.56 1.345v12.19c0 .524-.187.973-.56 1.346-.373.373-.821.56-1.345.56h-1.048z",
    fill: "#fff"
  }))));
}
export default SvgPause;